import WidgetEntity from '../WidgetEntity';
import * as Widgets from "@mm/constants/widgets";

export default class ImageWidget extends WidgetEntity {
  static make(pageId, sortOrder) {
    const widget = {
      ...super.make(pageId, Widgets.IMAGE, 'Untitled image', sortOrder),
      config: {
        title: 'Untitled image',
        // uploadId: null,
        assetId: null,
      },
      title: '',
    };

    delete widget.title;

    return widget;
  }
}
